import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p461688209195204608',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
